import Select from "react-select";

const SelectDropdown = ({ options, ...props }) => {
  return (
    <Select
      options={options}
      {...props}
      styles={{
        control: (provided, state) => ({
          ...provided,
          fontFamily: "var(--font-family1)",
          fontWeight: 600,
          fontSize: "16px",
          borderColor: state.isFocused ? "black" : "#ced4da",
          boxShadow: state.isFocused ? "0 0 0 1px black" : "none",
        }),
        menu: (provided) => ({
          ...provided,
          fontFamily: "var(--font-family1)",
          fontWeight: 600,
          fontSize: "16px",
          outline: "none",
          "&:focus": {
            borderColor: "black",
            boxShadow: "0 0 0 1px black",
          },
        }),
        option: (provided, state) => ({
          ...provided,
          fontFamily: "var(--font-family1)",
          fontWeight: 600,
          fontSize: "16px",
          backgroundColor: state.isFocused ? "var(--color-orange)" : "white",
          color: state.isFocused ? "white" : "black",
        }),
        singleValue: (provided) => ({
          ...provided,
          fontFamily: "var(--font-family1)",
          fontWeight: 600,
          fontSize: "16px",
        }),
        placeholder: (provided) => ({
          ...provided,
          fontFamily: "var(--font-family1)",
          fontWeight: 500,
          fontSize: "16px",
        }),
        indicatorSeparator: () => ({
          display: "none",
        }),
      }}
    />
  );
};

export default SelectDropdown;
